import { render, staticRenderFns } from "./GeneralReportsWrapper.vue?vue&type=template&id=c3e3b166&"
import script from "./GeneralReportsWrapper.vue?vue&type=script&lang=js&"
export * from "./GeneralReportsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports